<code-input
  [codeLength]="6"
  [isFocusingOnLastByClickIfFilled]="true"
  [initialFocusField]="0"
  [disabled]="isSendingToServer"
  (codeCompleted)="codeCompleted($event)"
>
</code-input>
